import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={17}
    height={12}
    viewBox="0 0 17 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.75 4.77295C0.335786 4.77295 0 5.10874 0 5.52295C0 5.93716 0.335786 6.27295 0.75 6.27295L0.75 5.52295L0.75 4.77295ZM16.2803 6.05328C16.5732 5.76039 16.5732 5.28551 16.2803 4.99262L11.5074 0.219648C11.2145 -0.073245 10.7396 -0.073245 10.4467 0.219648C10.1538 0.512542 10.1538 0.987415 10.4467 1.28031L14.6893 5.52295L10.4467 9.76559C10.1538 10.0585 10.1538 10.5334 10.4467 10.8263C10.7396 11.1191 11.2145 11.1191 11.5074 10.8263L16.2803 6.05328ZM0.75 5.52295L0.75 6.27295L15.75 6.27295V5.52295V4.77295L0.75 4.77295L0.75 5.52295Z"
      fill="#4682B4"
    />
  </svg>
);

export default SVGComponent;
